import API from "Services/Api";
import { UpdateScheduleType } from "./types";


export const rescheduleOrder = async (schedule_id: string, date: string) => {
  try {
    const canceledOrder = await API.get(`appointments/reschedule/${schedule_id}/date/${date}`)

    return canceledOrder.data

  } catch (err) {
    console.error(err);
    throw "Ops! Ocorreu um erro ao reagendar o pedido";
  }

}

export const updateSchedule = async (address: UpdateScheduleType, schedule_id: string) => {
  try {
    const canceledOrder = await API.post(`appointments/update/${schedule_id}`, {
      ...address
    })

    return canceledOrder.data

  } catch (err) {
    console.error(err);
    throw "Ops! Ocorreu um erro ao reagendar o pedido";
  }



}